import * as Yup from "yup";
export const signInMethodsSchema = Yup.object({
  signInMethods: Yup.array()
    .of(Yup.string())
    .min(1, "At least one sign-in method is required"),
});
